module.exports = "dist/574fd0b50367f886d359e8264938fc37.woff2";


//////////////////
// WEBPACK FOOTER
// ./~/materialize-css/fonts/roboto/Roboto-Medium.woff2
// module id = 216
// module chunks = 0